import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _departments = [];
let _stats = {};

const sanitise = ({id, organisationId, ...rest}) => ({
    id: Number(id),
    organisationId: Number(organisationId) || null,
    ...rest
});

let DepartmentStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    getAll: function() {
         return _departments.filter(function(e) { return e !== undefined; });
    },
    getById: function(id) {
        return _departments.find(function(e) { return e !== undefined && e.id == id; });
    },
    getByOrganisation: function(organisationId) {
        return _departments.filter(function(e) { return e !== undefined && e.organisationId == organisationId; });
    },
    add: function(entity) {
        entity = sanitise(entity);
        if (!entity.id) { return; }
        const index = _departments.findIndex((e) => !!e  && e.id === entity.id );
        if (0 <= index) {
            _departments[index] = entity;
        } else {
            _departments.push(entity);
        }

    },
    remove: function(id) {
        _departments = _departments.filter(e => !!e && e.id !==  id);
    },
    getStats: function() {
        return _stats;
    },

});

DepartmentStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.DEPARTMENT_LIST:
        case ActionTypes.DEPARTMENT_DEFAULT:
            action.data.forEach(DepartmentStore.add);
            DepartmentStore.emitChange();
            break;

        case ActionTypes.DEPARTMENT_LIST_ERROR:
        case ActionTypes.DEPARTMENT_DEFAULT_ERROR:
            DepartmentStore.emitChange();
            break;

        case ActionTypes.DEPARTMENT_INFO:
            DepartmentStore.add(action.data);
            DepartmentStore.emitChange();
            break;

        case ActionTypes.DEPARTMENT_SAVE:
        case ActionTypes.DEPARTMENT_UPDATE:
            DepartmentStore.add(action.data);
            DepartmentStore.emitChange();
            break;

        case ActionTypes.DEPARTMENT_DELETE:
            if (!!action.data.id && !!action.data.deleted) {
                DepartmentStore.remove(Number(action.data.id));
            }
            DepartmentStore.emitChange();
            break;

        case ActionTypes.DEPARTMENT_INFO_ERROR:
        case ActionTypes.DEPARTMENT_UPDATE_ERROR:
        case ActionTypes.DEPARTMENT_SAVE_ERROR:
        case ActionTypes.DEPARTMENT_DELETE_ERROR:
            DepartmentStore.emitChange();
            break;

        case ActionTypes.DEPARTMENT_STATS:
            _stats = action.data;
            DepartmentStore.emitChange();
            break;

        default:
            break;

    }

});

export default DepartmentStore;
